module.exports = __webpack_public_path__ + "static/media/A36.97f166fc.png";